<ng-container *transloco="let t">
  <p-dialog
    [visible]="visible"
    [modal]="modal"
    [closable]="closable"
    [draggable]="draggable"
    [resizable]="resizable"
    [styleClass]="size"
    (visibleChange)="onClose($event)"
  >
    <p-header>{{ title }}</p-header>

    <div class="p-grid">
      <div *ngIf="icon" class="p-col-fixed"><i class="dialog-icon" [ngClass]="icon"></i></div>
      <div class="p-col">
        <ng-container *ngIf="content">
          <ng-content *ngTemplateOutlet="content"></ng-content>
        </ng-container>
        <ng-container *ngIf="!content && message">{{ message }}</ng-container>
      </div>
    </div>

    <div class="modal-footer">

      <ng-container *ngIf="footer">
        <ng-content *ngTemplateOutlet="footer"></ng-content>
      </ng-container>

      <ng-container *ngIf="!footer">
        <div class="p-text-right">
          <button *ngIf="rejectVisible" pButton type="button" [label]="rejectLabel" (click)="onRejectClicked()" class="p-button-outlined"></button>
          <button *ngIf="acceptVisible" pButton type="button" [label]="acceptLabel" (click)="onAcceptClicked()" class="p-ml-2"></button>
        </div>
      </ng-container>

    </div>
  </p-dialog>
</ng-container>
